import React from 'react';
import { observer } from 'src/utils/mobx-react';

import TRAP_1 from './assets/trap-1.png';
import TRAP_2 from './assets/trap-2.png';
import TRAP_3 from './assets/trap-3.png';
import TRAP_4 from './assets/trap-4.png';
import TRAP_5 from './assets/trap-5.png';
import TRAP_6 from './assets/trap-6.png';

const TRAPS: Record<string, string> = {
    '1': TRAP_1,
    '2': TRAP_2,
    '3': TRAP_3,
    '4': TRAP_4,
    '5': TRAP_5,
    '6': TRAP_6
};

interface PropsTypes {
    number: number,
    placeholder?: string,
    className?: string
}

export const Trap = observer('Trap', ({ number, placeholder, className }: PropsTypes) => {
    return (
        <img className={ className !== undefined ? className : '' } src={ TRAPS[number] ?? placeholder ?? '' } alt='' />
    );
});


export default Trap;
